import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import * as THREE from 'three'

/*const calculateHeightWithLid2 = async (glbFile) => {
    const loader = new GLTFLoader();
    
    let minZ = Infinity;
    let maxZ = -Infinity;
    
    const promise = new Promise((resolve, reject) => {
        loader.load(glbFile, (gltf) => {
            gltf.scene.traverse((child) => {
                if (child.position) {
                    const { z } = child.position;
                    minZ = Math.min(minZ, z);
                    maxZ = Math.max(maxZ, z);
                }
            });
            resolve(maxZ - minZ);
        }, undefined, reject);
    });
    return await promise;
};*/

const calculateHeightWithLid = async (glbFile) => {

  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');

  const loader = new GLTFLoader()
  loader.setDRACOLoader(dracoLoader);

  let product

  const promise = new Promise((resolve, reject) => {
    loader.load(
      glbFile,
      (gltf) => {
        product = gltf.scene
        resolve()
      },
      undefined,
      reject
    )
  })

  await promise

  if (product === undefined) return null
  const box = new THREE.Box3().setFromObject(product)
  const size = box.getSize(new THREE.Vector3())

  return {
    x: size.x * 1000,
    y: size.y * 1000,
    z: size.z * 1000,
  }
}
export default calculateHeightWithLid

/*
const getSizeOfProduct = () => {
    let product = threeViewer.product
    if (product === undefined) return null
    let box = new THREE.Box3().setFromObject(product)
    let size = box.getSize(new THREE.Vector3())
    return {
        width: Math.round(size.x * 1000),
        height: Math.round(size.y * 1000),
    }
}*/
